import { render, staticRenderFns } from "./company-list.vue?vue&type=template&id=eab458be&scoped=true"
import script from "./company-list.vue?vue&type=script&lang=js"
export * from "./company-list.vue?vue&type=script&lang=js"
import style0 from "./company-list.vue?vue&type=style&index=0&id=eab458be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab458be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eab458be')) {
      api.createRecord('eab458be', component.options)
    } else {
      api.reload('eab458be', component.options)
    }
    module.hot.accept("./company-list.vue?vue&type=template&id=eab458be&scoped=true", function () {
      api.rerender('eab458be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/companies/list/company-list.vue"
export default component.exports